import { render, staticRenderFns } from "./propertyROI.vue?vue&type=template&id=30a39963&"
import script from "./propertyROI.vue?vue&type=script&lang=js&"
export * from "./propertyROI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports